import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API });

export async function fetchOverview() {
  const { data } = await client.get("/overview");
  return data;
}

export async function fetchHistory() {
  const { data } = await client.get("/history", { params: { back: 10, forward: 2 } });
  return data;
}

export async function fetchIslandDetail(id) {
  const { data } = await client.get(`/island/${id}`);
  return data;
}

export function modisUrl({ width = 1024, height = 640, date } = {}) {
  const p = new URLSearchParams({ width, height });
  if (date) p.set("date", date);
  return `${API}/satellite/modis?${p.toString()}`;
}

export function sentinelUrl({ west, south, east, north, width = 768, height = 768, days = 45 }) {
  const p = new URLSearchParams({ west, south, east, north, width, height, days });
  return `${API}/satellite/sentinel2?${p.toString()}`;
}

export function briefingUrl(islandId) {
  return `${API}/briefing/${islandId}`;
}

export async function fetchFishingAdvisory(species) {
  const { data } = await client.get("/fishing/advisory", {
    params: species ? { species } : {},
  });
  return data;
}

export async function fetchScoreboard() {
  const { data } = await client.get("/scoreboard");
  return data;
}

export async function submitFishingReport(formData) {
  const { data } = await client.post("/fishing/report", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data;
}

export function fileUrl(path) {
  return `${API}/files/${path}`;
}
